import { causeError } from 'libs/types/checkTypes';
import { Type, Tab } from '../const';

/**
 * @function assignOrder
 * @param { string } type tab || subtabs
 * @param { array } values tabs || subtabs
 * @returns { array }
 */
function assignOrder(type, values) {
	let results = null;

	if (type === Type.Tab) {
		results = values.map((value, index) => {
			return {
				[Tab.GroupId]: value[Tab.GroupId],
				[Tab.Id]: value[Tab.Id],
				[Tab.Name]: value[Tab.Name],
				[Tab.Url]: value[Tab.Url],
				[Tab.Desc]: value[Tab.Desc],
				[Tab.Order]: String(index + 1),
				[Tab.Subtabs]: value[Tab.Subtabs],
				[Tab.SubtabId]: value[Tab.SubtabId],
				[Tab.Checked]: value[Tab.Checked],
				[Tab.Open]: value[Tab.Open],
			};
		});
	} else {
		causeError('Cause error at the assignOrder() method!');
	}

	return results;
}

export default assignOrder;
